import * as React from "react";
import { styled } from "@material-ui/core/styles";
import CheckmarkIconSrc from "../assets/checkmark-icon.png";

const Img = styled("img")(() => ({
  width: 20,
  height: 20,
}));

export const CheckmarkIconImg = React.forwardRef(function CheckmarkIconImg(
  props,
  ref,
) {
  return <Img src={CheckmarkIconSrc} alt="" ref={ref} {...props} />;
});
